import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/EnablePerm.module.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function SuccessPassChange({ OnClose, OnConfirm }) {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const navigate = useNavigate();
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <div className={styles.success_img}></div>
        <div className={styles.title_green}>
          {dublicatedcontent.dublicatedText221}
        </div>
        <div className={styles.title1}>
          {dublicatedcontent.dublicatedText222}
        </div>
        <div className={styles.footer}>
          <div
            onClick={() => {
              navigate("/user/account#recovery");
            }}
            className={styles.bluebutton}
          >
            {dublicatedcontent.dublicatedText76}
          </div>
        </div>
      </div>
    </div>
  );
}
export { SuccessPassChange };
